import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeSection = ({ userName, company }) => {
  return (
    <div className="mb-8">
      <div className="bg-gradient-to-r from-[#1FB5A5]/20 to-[#002B45]/20 backdrop-blur-sm rounded-xl p-8 border border-[#1FB5A5]/30">
        <div className="flex items-start justify-between">
          <div>
            <h1 className="text-3xl font-bold text-white mb-2">
              Welcome back, {userName}!
            </h1>
            {company && (
              <p className="text-[#1FB5A5] text-lg font-medium">{company}</p>
            )}
            <p className="text-gray-300 mt-4 max-w-2xl">
              Your personalized data maturity dashboard. Track your progress, access consultation history, and explore tailored recommendations to accelerate your data transformation journey.
            </p>
          </div>
          <div className="w-16 h-16 bg-[#1FB5A5] rounded-full flex items-center justify-center">
            <Icon name="User" size={32} className="text-white" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;